var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-snackbar',{attrs:{"value":_vm.showing,"timeout":_vm.timeout,"top":_vm.props.top,"left":_vm.props.left,"right":_vm.props.right,"color":_vm.props.color,"max-width":"290"},on:{"input":_vm.handleClose}},[_c(_vm.component,_vm._b({tag:"component",on:{"onClose":_vm.handleClose}},'component',_vm.props,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }